import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { BaseInputComponent } from '../base-input/base-input.component';
import { TextAreaInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TextareaComponent extends BaseInputComponent implements OnInit, AfterViewInit {
    @Input() input: TextAreaInputType;
    @ViewChild(MatInput) textArea: MatInput;
    hasMaxChars: boolean;
    constructor(private questionStateService: QuestionStateService, private changeDetect: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.initialize(this.input, this.questionStateService);
        this.hasMaxChars = this.input.maxChars > 0;
        this.input.rows = this.input.rows ? this.input.rows : 2;
    }
    ngAfterViewInit() {
        if (this.textArea) {
            this.inputIdEvent.emit(this.textArea.id);
        }
        //we need to do this because we are setting attr.aria-describedby
        //there is a bug that the input.id is added after view detection
        this.changeDetect.detectChanges();
    }
}
